export const ChipColorStyles = [
  { bg: "#FFCDD2", color: "#B71C1C" }, // light red
  { bg: "#F8BBD0", color: "#880E4F" }, // light pink
  { bg: "#E1BEE7", color: "#4A148C" }, // light purple
  { bg: "#D1C4E9", color: "#311B92" }, // lavender
  { bg: "#C5CAE9", color: "#1A237E" }, // light indigo
  { bg: "#BBDEFB", color: "#0D47A1" }, // light blue
  { bg: "#B3E5FC", color: "#01579B" }, // cyan
  { bg: "#B2EBF2", color: "#006064" }, // teal
  { bg: "#B2DFDB", color: "#004D40" }, // light greenish teal
  { bg: "#C8E6C9", color: "#1B5E20" }, // pale green
  { bg: "#DCEDC8", color: "#33691E" }, // lime
  { bg: "#F0F4C3", color: "#827717" }, // yellow-green
  { bg: "#FFF9C4", color: "#F57F17" }, // light yellow
  { bg: "#FFECB3", color: "#E65100" }, // soft amber
  { bg: "#FFE0B2", color: "#BF360C" }, // peach/orange
  { bg: "#FFCCBC", color: "#D84315" }, // salmon
  { bg: "#D7CCC8", color: "#3E2723" }, // brown
  { bg: "#CFD8DC", color: "#263238" }, // blue-grey
];
